import { type FC, type ReactNode } from 'react';

interface SummaryTableLineItemRowProps {
  description: string;
  quantity: string;
  recurringCharge?: ReactNode;
  total?: string;
  proratedRecurringCharge?: ReactNode;
}

const SummaryTableLineItemRow: FC<SummaryTableLineItemRowProps> = ({
  description,
  quantity,
  recurringCharge,
  total,
  proratedRecurringCharge,
}) => (
  <tr className="SummaryTable__row">
    <td className="SummaryTable__cell">{description}</td>
    <td className="SummaryTable__cell">{quantity}</td>
    <td className="SummaryTable__cell">{recurringCharge}</td>
    {proratedRecurringCharge && <td className="SummaryTable__cell">{proratedRecurringCharge}</td>}
    <td className="SummaryTable__cell SummaryTable__cell--total">{total}</td>
  </tr>
);

export default SummaryTableLineItemRow;
